var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M33.14,26.46A10.78,10.78,0,0,1,33,28,11.83,11.83,0,0,1,29.47,35a11.87,11.87,0,0,1-8.19,3.28,11.7,11.7,0,0,1-3.9-.66,10.68,10.68,0,0,1-1.73-.76A11.49,11.49,0,0,1,13.09,35a11.84,11.84,0,0,1-3.53-6.72h0a11.23,11.23,0,0,1-.14-1.84,14,14,0,0,1,.14-1.86,12,12,0,0,1,.4-1.7,11.88,11.88,0,0,1,3.42-5.28,11.65,11.65,0,0,1,7.9-3,12.07,12.07,0,0,1,3.78.61,11.54,11.54,0,0,1,4.12,2.41A11.72,11.72,0,0,1,33,24.93,10.83,10.83,0,0,1,33.14,26.46Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23.86 21.98 18.69 21.98 16.1 26.45 18.69 30.93 23.86 30.93 26.45 26.45 23.86 21.98",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.18,17.62H26.45l-1.39-2.41",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2,15.31l-1.33,2.31H13.38",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,28l-.87-1.52L33,24.93",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.56,24.6l1.07,1.86L9.56,28.3",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.09,35h2.78l1.51,2.62",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.88,37.75,26.45,35h3",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.33,
    y1: 22.9,
    x2: 26.45,
    y2: 17.62,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.23,
    y1: 22.9,
    x2: 15.86,
    y2: 17.62,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.17,
    y1: 26.45,
    x2: 10.63,
    y2: 26.45,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.23,
    y1: 30.01,
    x2: 15.86,
    y2: 35.03,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.33,
    y1: 30.01,
    x2: 26.45,
    y2: 35.03,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.38,
    y1: 26.45,
    x2: 32.17,
    y2: 26.45,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.65,2.09a21.2,21.2,0,0,1-8.72,6.57c-2.58,1-5.86,1.83-5.86,1.83-1.87.5-2.66.63-4.2,1.15a27.72,27.72,0,0,0-4.52,2A15.32,15.32,0,0,0,5.94,25.74a14.93,14.93,0,0,0,3.23,9.91,17.12,17.12,0,0,0,7,5,29,29,0,0,0,8,1.65l1.62.19c2.51.34,4.55.74,5.18.88,3.54.8,7.61,3.61,8.89,4.52",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,25.3a86.47,86.47,0,0,1,37.39-11",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.18,29.06a90.52,90.52,0,0,0,16.43,4.87,91.41,91.41,0,0,0,21.47,1.61",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.17,10.05a29.14,29.14,0,0,1,5,15.78,29.16,29.16,0,0,1-5,16.68",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal);
export default __webpack_public_path__ + "static/media/GOAL.847d08f8d7a29236e5f3ea304511a9a6.svg";
export { ForwardRef as ReactComponent };